export const humanizeStatus = (status) => {
  if (typeof status !== 'string') return ''

  const normalizedStatus = status
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, ' ')

  if (!normalizedStatus) return ''

  return `${normalizedStatus.charAt(0).toUpperCase()}${normalizedStatus.slice(
    1
  )}`
}
